export class CallInfo{
    payerRepresentative: string = '';
    phoneCallDate: string = '';
    phoneDialed: string = '';
    callReference: string = '';
    ediNumber : string = '';
}